module.exports = __webpack_public_path__ + "img/sol_cap5.59b26e90.png";